import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
const ThemeContext = createContext(undefined);
export const ThemeProvider = ({ children, defaultTheme = 'system', storageKey = 'vite-ui-theme', }) => {
    const [theme, setTheme] = useState(defaultTheme);
    const [isDark, setIsDark] = useState(false);
    // Initialize theme from localStorage or system preference
    useEffect(() => {
        const stored = localStorage.getItem(storageKey);
        if (stored) {
            setTheme(stored);
        }
        else {
            setTheme(defaultTheme);
        }
    }, [defaultTheme, storageKey]);
    // Apply theme to document and update isDark state
    useEffect(() => {
        const root = window.document.documentElement;
        const applyTheme = (themeValue) => {
            if (themeValue === 'system') {
                const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')
                    .matches
                    ? 'dark'
                    : 'light';
                root.classList.toggle('dark', systemTheme === 'dark');
                setIsDark(systemTheme === 'dark');
            }
            else {
                root.classList.toggle('dark', themeValue === 'dark');
                setIsDark(themeValue === 'dark');
            }
        };
        applyTheme(theme);
    }, [theme]);
    // Listen for system theme changes
    useEffect(() => {
        if (theme === 'system') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            const handleChange = (e) => {
                const root = window.document.documentElement;
                root.classList.toggle('dark', e.matches);
                setIsDark(e.matches);
            };
            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        }
    }, [theme]);
    const value = {
        theme,
        setTheme: (theme) => {
            localStorage.setItem(storageKey, theme);
            setTheme(theme);
        },
        isDark,
        toggleTheme: () => {
            const newTheme = isDark ? 'light' : 'dark';
            localStorage.setItem(storageKey, newTheme);
            setTheme(newTheme);
        },
    };
    return (_jsx(ThemeContext.Provider, { value: value, children: children }));
};
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
